import React, { useState } from 'react';
import { ethers } from 'ethers';
import {
  NavContainer,
  MainLogo,
  ProfilePictureStyled,
  ConnectWalletButton,
  DropdownMenu,
  NavItemContainer
} from '../../styles/Navbar.styled';

import DigstersLogo from '../../assets/Logos/DIGSTERS.svg';
import ProfilePicture from '../../assets/Logos/ProfilePicture.svg';
import { printEthAccount, printEthBalance } from '../../utils/strings';

export const NavBar = () => {
  const [account, setAccount] = useState<string>('');
  const [userBalance, setUserBalance] = useState<string>('');
  const [isDropDownMenuVisible, setIsDropDownMenuVisible] =
    useState<Boolean>(false);

  const connectWalletHandler = async () => {
    if (window.ethereum && window.ethereum.isMetaMask) {
      try {
        const result: Array<string> = await window.ethereum.request({
          method: 'eth_requestAccounts'
        });
        console.log('results : ', result);
        if (result.length) {
          setAccount(result[0]);
          getAccountBalance(result[0]);
        } else {
          setAccount('');
        }
      } catch (err) {
        console.log(err);
      }
      window.ethereum.on('accountsChanged', accountChangedHandler);
      window.ethereum.on('chainChanged', chainChangedHandler);
    } else {
      console.log('Need to install MetaMask');
    }
  };

  const accountChangedHandler = (newAccount: string) => {
    console.log('Account changed: ' + newAccount);
    if (newAccount.toString().length) {
      setAccount(newAccount.toString());
    } else {
      setAccount('');
      setUserBalance('0');
    }
  };

  const getAccountBalance = async (account: string) => {
    if (account) {
      console.log('MetaMask Here!');
      try {
        const balance: string = await window.ethereum.request({
          method: 'eth_getBalance',
          params: [account, 'latest']
        });
        setUserBalance(ethers.utils.formatEther(balance));
      } catch (err) {
        console.log(err);
      }
    } else {
      console.log('Need to connect Wallet');
    }
  };

  const chainChangedHandler = () => {
    window.location.reload();
  };

  return (
    <NavContainer>
      <NavItemContainer>
        <a href="https://digsters.io/" target="_blank" rel="noreferrer">
          <MainLogo src={DigstersLogo} alt="Digster Logo" />
        </a>
        {account ? (
          <div style={{ position: 'relative' }}>
            <ProfilePictureStyled
              onClick={() => setIsDropDownMenuVisible(!isDropDownMenuVisible)}
              src={ProfilePicture}
              alt="Profile Picture"
            />
            {isDropDownMenuVisible ? (
              <DropdownMenu>
                {printEthAccount(account)}
                <br />
                {printEthBalance(userBalance)}
              </DropdownMenu>
            ) : null}
          </div>
        ) : (
          <ConnectWalletButton onClick={connectWalletHandler}>
            Connect Wallet
          </ConnectWalletButton>
        )}
      </NavItemContainer>
    </NavContainer>
  );
};
